import { useState, type FormEvent } from 'react';
import { changeOwnPassword, type AuthUser } from '../api/client';

interface AccountPageProps {
  user: AuthUser | null;
}

export function AccountPage({ user }: AccountPageProps) {
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    if (newPassword !== confirm) {
      setError('New password and confirmation do not match');
      return;
    }
    setBusy(true);
    try {
      await changeOwnPassword(currentPassword, newPassword);
      setCurrent('');
      setNewPw('');
      setConfirm('');
      setSuccess('Password updated.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to update password');
    } finally {
      setBusy(false);
    }
  }

  if (!user) return null;

  return (
    <div>
      <h2 className="mb-6">Account</h2>

      <div className="card mb-6">
        <div className="card-header">Profile</div>
        <div className="card-body">
          <table className="info-table">
            <tbody>
              <tr><td className="text-secondary" style={{ width: '40%' }}>Username</td><td>{user.username}</td></tr>
              <tr><td className="text-secondary">Role</td><td>{user.role}</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="card" style={{ maxWidth: 520 }}>
        <div className="card-header">Change password</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Current password</label>
              <input
                className="form-input"
                type="password"
                autoComplete="current-password"
                required
                value={currentPassword}
                onChange={(e) => setCurrent(e.target.value)}
                disabled={busy}
              />
            </div>
            <div className="form-group">
              <label>New password (min 8 chars)</label>
              <input
                className="form-input"
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
                value={newPassword}
                onChange={(e) => setNewPw(e.target.value)}
                disabled={busy}
              />
            </div>
            <div className="form-group">
              <label>Confirm new password</label>
              <input
                className="form-input"
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                disabled={busy}
              />
            </div>
            {error && <div className="login-error">{error}</div>}
            {success && (
              <div style={{ padding: '10px 14px', background: '#dcfce7', color: '#166534', borderRadius: 4, fontSize: '0.88rem', marginBottom: 16 }}>
                {success}
              </div>
            )}
            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy ? 'Saving...' : 'Update password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
